<template>
<layout-content>
  <template #toolbar>
    <data-time-query :query="query" />

    <el-select v-model="query.siteIds[0]" size="small" @change="onSearchBtnClick">
      <el-option
        v-for="site in filterSites"
        :key="site.id"
        :value="site.id"
        :label="site.name"
      />
    </el-select>

    <completed-query v-model="query.isAuditCompleted" :is-show-fuse="false" @change="onAuditCompletedChanged" />

    <el-button
      :disabled="canNotSearch"
      type="orange"
      size="small"
      icon="el-icon-search"
      @click="onSearchBtnClick"
    >查询</el-button>
  </template>

  <template #body>
    <section class="data-wrapper">
      <section
        v-for="data in dataList"
        :key="data.siteId"
        v-if="data.data.length > 0"
        class="site-data"
      >
        <div class="site-data-header">
          <span>{{data.siteName}}</span>
        </div>
        <section class="site-data-body">
          <wind-statistical :p-query="currentQuery" :data="windData" style="margin-bottom:1rem;" />

          <section
            v-for="factor in selectedFactors"
            :key="factor.id"
            style="display:inline-block;width:33%;height:260px;"
          >
            <wind-rose-chart
              ref="charts"
              :factor="factor"
              :data="data"
            />
          </section>
        </section>
      </section>
    </section>
  </template>
</layout-content>
</template>

<script>
import BaseMeteorological from '../BaseMeteorological'
import WindRoseChart from '../../../../../components/Data/WindRoseChart'
import DataTimeQuery from '../../../../../components/Data/Query/DataTimeQuery'
import WindStatistical from './WindStatistical'

export default {
  name: 'StatisticalAnalysisWindRose',
  routeInfo: {
    label: '风玫瑰图',
    icon: 'fa fa-users'
  },
  extends: BaseMeteorological,
  components: {WindStatistical, DataTimeQuery, WindRoseChart},
  data () {
    return {
      query: {
        granularity: 1,
        isSiteMerge: false,
        isTimeMerge: false,
        isMultipleIntegral: true
      },
      windData: Object.freeze([])
    }
  },
  computed: {
    siteDeviceCategory: () => process.env.SO2_DEVICE_CATEGORY | process.env.NO_DEVICE_CATEGORY | process.env.CO_DEVICE_CATEGORY | process.env.O3_DEVICE_CATEGORY | process.env.PM_DEVICE_CATEGORY
  },
  methods: {
    onAuditCompletedChanged () {
      this.getData()
    },
    getData () {
      let currentQuery = this.currentQuery = JSON.parse(JSON.stringify(this.query))

      this.changeLoadStatus(true)
      Promise.all([
        this.$api.Data.getAQIData(currentQuery),
        this.$api.Data.getHistoryData({
          ...currentQuery,
          factorIds: ['1010', '1011', '1012', '1013', '1014', '8000', '8001']
        })
      ]).then(([aqiData, windData]) => {
        this.setSelectedFactors()
        this.formatData(aqiData, windData.filter(data => data.factorId === '1013'))
        this.renderData()
        this.windData = Object.freeze(windData)
      }).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    setSelectedFactors () {
      let {factorMap} = this
      this.selectedFactors = Object.freeze([{
        id: 'aqi',
        name: 'AQI',
        stdUnit: '',
        displayUnit: ''
      }].concat(['1001', '1003', '1005', '1006', '1007', '1008'].map(factorId => factorMap[factorId])))
    },
    formatData (aqiData, windData) {
      let {filterSiteMap} = this
      let {siteIds} = this.currentQuery
      let valPropSet = new Set()
      let iaqiPropSet = new Set()
      let dataMap = siteIds.reduce((map, siteId) => {
        map[siteId] = {
          siteId,
          siteName: filterSiteMap[siteId].name,
          data: {}
        }

        return map
      }, {})

      aqiData.reduce((map, aqiData) => {
        let {siteId} = aqiData
        let siteData = map[siteId]

        if (!siteData) {
          return map
        }

        siteData = siteData.data
        let {dataTime} = aqiData
        let data = siteData[dataTime]

        if (!data) {
          data = siteData[dataTime] = {}
        }

        data.aqiIaqi = aqiData.aqi
        let pollutantData = aqiData.pollutantData || []

        pollutantData.forEach(pollutantData => {
          let {factorId} = pollutantData
          let valueProp = `${factorId}Val`
          let iaqiProp = `${factorId}Iaqi`

          valPropSet.add(valueProp)
          iaqiPropSet.add(iaqiProp)

          data[valueProp] = pollutantData.value
          data[iaqiProp] = pollutantData.iaqi
        })

        return map
      }, dataMap)

      windData.reduce((map, windData) => {
        let {siteId} = windData

        let siteData = map[siteId]

        if (!siteData) {
          return map
        }

        siteData = siteData.data
        let {dataTime} = windData
        let data = siteData[dataTime]

        if (!data) {
          return map
        }

        data[windData.factorId] = windData.value

        return map
      }, dataMap)

      this.dataList = Object.freeze(Object.values(dataMap).map(data => ({
        siteId: data.siteId,
        siteName: data.siteName,
        data: Object.values(data.data)
      })))
    }
  }
}
</script>

<style lang="scss" scoped>
.site-selector {
  line-height: 1.7;
  -webkit-font-smoothing: antialiased;
}

.tree-popover-wrapper {
  max-height: 300px;
  overflow: auto;
}

.data-wrapper {
  .site-data {
    & + .site-data {
      margin-top: 20px;
    }
  }

  .site-data-header {
    line-height: 1.8em;
    padding: 0 10px;
    background: -webkit-gradient(linear, left top, right top, from(#fbc15a), to(#fff));
    background: linear-gradient(to right, #fbc15a 0%, #fff 100%);
    color: #ffffff;
    font-weight: 600;
  }

  .site-data-body {
    font-size: 0;
    padding: 1rem 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/03Pollution/01Meteorological/02Wind-Rose/index.vue